module.exports = __webpack_public_path__ + "img/669.e65570af.jpg";